import { render } from "./Colocation.vue?vue&type=template&id=62256214"
import script from "./Colocation.vue?vue&type=script&lang=js"
export * from "./Colocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__